// Store de alertas — chat de pregões e notificações
import { apiGet, apiPost } from '@/api/conserv';

// Lista anexos de um produto em um pregão
export async function listaAnexosProd(idRegportal, item) {
    return apiGet(`api/Alertas/ListaAnexosProd?idReg=${idRegportal}&item=${item}`);
}

// Ativa modo de chat de um pregão (marca como aberto)
export async function chatOn(idRegportal, idPortal) {
    return apiGet(`api/Alertas/ChatOn?idReg=${idRegportal}&idPortal=${idPortal}`);
}

// Lista produtos de um pregão para exibição no chat
export async function listaProdutos(idRegportal, idPortal) {
    return apiGet(`api/Alertas/ListaProdutos?idReg=${idRegportal}&idPortal=${idPortal}`);
}

// Marca todos os alertas do usuário como lidos (full)
export async function marcaLidoFull(dados) {
    return apiPost('api/Alertas/MarcaLidoFull', dados);
}

// Marca todos os alertas de um pregão como lidos
export async function marcaLidoTodos(idReg) {
    return apiPost(`api/Alertas/MarcaLidoTodos?idReg=${idReg}`, '');
}

// Marca um alerta específico como lido
export async function marcaLido(id) {
    return apiPost(`api/Alertas/MarcaLido?idReg=${id}`, '');
}

// Lista pregões que o usuário está acompanhando
export async function listaPregoesAcomp() {
    return apiGet('api/Alertas/ListaPregoesAcomp');
}

// Lista alertas de um pregão específico
export async function listaAlertasPregao(idPreg) {
    return apiGet(`api/Alertas/ListaAlertasPregao?idPreg=${idPreg}`);
}

// Envia mensagem no chat de um pregão
export async function sendMessage(dados) {
    return apiPost('api/Alertas/SendMessage', dados);
}

// ---- Palavras-chave de alertas (PLS) ----

// Lista todas as palavras-chave de alertas do usuário
export async function listaPlsAlertas() {
    return apiGet('api/Alertas/ListaPlsAlertas');
}

// Cadastra/atualiza um grupo de palavras-chave de alerta
export async function cadastraPls(dados) {
    return apiPost('api/Alertas/CadastraPls', dados);
}

// Exclui um grupo de palavras-chave de alerta
export async function deletaPls(idReg) {
    return apiPost(`api/Alertas/DeletaPls?idReg=${idReg}`, '');
}
